import { Button, LinearProgress, Theme } from "@material-ui/core"
import { ButtonProps } from "@material-ui/core/Button"
import { createStyles, WithStyles, withStyles } from "@material-ui/styles"
import React from "react"
import { compose } from "react-apollo"
import BigButton from "../BigButton"

const styles = (theme: Theme) =>
    createStyles({
        linearColorPrimary: {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
        },
        linearBarColorPrimary: {
            backgroundColor: "rgba(255, 255, 255, 0.8)",
        },
        variantOutlinedLinearColorPrimary: {
            backgroundColor: theme.palette.primary.main + "22!important",
        },
        variantOutlinedLinearBarColorPrimary: {
            backgroundColor: theme.palette.primary.main + "EE!important",
        },
    })

interface Props extends WithStyles<typeof styles> {
    bigButton: boolean
    children: React.ReactNode
    className: string
    fullRound: boolean
    isSubmitting: boolean
    href?: string
    target?: string
}

class SubmitButton extends React.Component<Props & ButtonProps> {
    static defaultProps = {
        bigButton: true,
        fullRound: true,
        className: "",
    }

    handleOnClick = (e) => {
        if (this.props.onClick && !this.props.isSubmitting) {
            if (e) {
                e.preventDefault()
            }

            this.props.onClick(e)
        }
    }

    render() {
        const {
            classes,
            children,
            isSubmitting,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onClick,
            style,
            bigButton,
            fullRound,
            className,
            ...restProps
        } = this.props

        return bigButton ? (
            // @ts-ignore
            <BigButton
                id="checkout"
                type="submit"
                className={className}
                onClick={this.handleOnClick}
                style={{
                    overflow: "hidden",
                    pointerEvents: isSubmitting ? "none" : "auto",
                    ...style,
                }}
                fullRound={fullRound}
                {...restProps}>
                <div>
                    {isSubmitting && (
                        <LinearProgress
                            classes={{
                                colorPrimary:
                                    this.props.variant === "outlined"
                                        ? classes.variantOutlinedLinearColorPrimary
                                        : classes.linearColorPrimary,
                                barColorPrimary:
                                    this.props.variant === "outlined"
                                        ? classes.variantOutlinedLinearBarColorPrimary
                                        : classes.linearBarColorPrimary,
                            }}
                            style={{
                                position: "absolute",
                                left: "0px",
                                bottom: "0px",
                                width: "100%",
                                height: "2px",
                            }}
                        />
                    )}
                    {children}
                </div>
            </BigButton>
        ) : (
            <Button
                id="checkout"
                type="submit"
                onClick={this.handleOnClick}
                className={className}
                style={{
                    overflow: "hidden",
                    pointerEvents: isSubmitting ? "none" : "auto",
                    ...style,
                }}
                {...restProps}>
                {isSubmitting && (
                    <LinearProgress
                        classes={{
                            colorPrimary:
                                this.props.variant === "outlined"
                                    ? classes.variantOutlinedLinearColorPrimary
                                    : classes.linearColorPrimary,
                            barColorPrimary:
                                this.props.variant === "outlined"
                                    ? classes.variantOutlinedLinearBarColorPrimary
                                    : classes.linearBarColorPrimary,
                        }}
                        style={{
                            position: "absolute",
                            bottom: "0px",
                            left: "0px",
                            width: "100%",
                            height: "2px",
                        }}
                    />
                )}
                {children}
            </Button>
        )
    }
}

const composed = compose(withStyles(styles))

export default composed(SubmitButton)
